import { render } from "./TrekMarquee.vue?vue&type=template&id=1ecdee46&scoped=true"
import script from "./TrekMarquee.vue?vue&type=script&lang=js"
export * from "./TrekMarquee.vue?vue&type=script&lang=js"

import "./TrekMarquee.vue?vue&type=style&index=0&id=1ecdee46&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecdee46"]])

export default __exports__